import { Component, ElementRef, OnDestroy, ViewChild } from "@angular/core";
import { Subject } from "rxjs";
import { SurveyPhotoTypeEnum } from "src/app/shared/Models/enums/SurveyPhotoTypeEnum";
import { PhotoObjectDto } from "src/app/shared/Models/write/PhotoObjectDto";
import { AnnotationService } from "../annotation.service";
import { Coord } from "../stroke-data";

@Component({
  selector: "app-canvas",
  templateUrl: "./canvas.component.html",
  styleUrls: ["./canvas.component.scss"],
})
export class CanvasComponent implements OnDestroy {
  constructor(private annotationService: AnnotationService) {}

  @ViewChild("canvas") canvas: ElementRef<HTMLCanvasElement>;

  onSave: Subject<PictureData> = new Subject<PictureData>();
  onCancel = new Subject();

  toImage(canvas: HTMLCanvasElement, img: HTMLImageElement) {
    img.src = this.annotationService.getImageUrl(canvas);
  }

  loadImg(src: File | string, onloadHandler?: () => void) {
    this.annotationService.loadImg(
      src,
      this.canvas.nativeElement,
      onloadHandler
    );
  }
  setPoints(points: Coord[], canvas: HTMLCanvasElement) {
    this.annotationService.setCoords(points, canvas);
  }

  undoLast(canvas: HTMLCanvasElement) {
    this.annotationService.undoLastStroke(canvas);
  }

  reset() {
    this.annotationService.reset(this.canvas.nativeElement);
  }

  clearImage() {
    this.annotationService.clearImage(this.canvas.nativeElement);
  }

  rotate(canvas: HTMLCanvasElement, clockwise: boolean) {
    this.annotationService.rotate(canvas, clockwise);
  }

  flip(canvas: HTMLCanvasElement, horizontal: boolean) {
    this.annotationService.flip(canvas, horizontal);
  }

  save(canvas: HTMLCanvasElement) {
    this.annotationService
      .getPictureData(canvas)
      .then((data) => this.onSave.next(data));
  }

  cancel() {
    this.onCancel.next(true);
  }

  ngOnDestroy() {
    this.onSave.complete();
    this.onCancel.complete();
  }
}

export class PictureData {
  id: string;
  type: SurveyPhotoTypeEnum;
  mimeType: string;
  originalBlob: File;
  url: string;
  originalUrl: string;
  blob: File;
  addressId: string;
  backgroundImageMetadata: string;
  items: PhotoObjectDto[];
  state: PictureUploadState;
}

export enum PictureUploadState {
  ongoing,
  done,
  failed,
}
